import styled from 'styled-components'
import Connector from '@assets/images/connector-inactive.png'
import ActiveConnector from '@assets/images/connector-active.png'

const minWidth = '550px'

const Container = styled.ul`
  height: 75px;
  display: flex;
  align-items: start;
  justify-content: space-between;
  position: relative;
  margin: 10px 0;
  transition: all 0.5s;

  @media screen and (min-width: ${minWidth}) {
    justify-content: start;
  }
`
const Item = styled.li`
  position: relative;

  @media screen and (min-width: ${minWidth}) {
    display: flex;
    align-items: center;
  }
  &:nth-child(3) p {
    width: 70px;
  }
  &:last-child p {
    margin-right: 0;
  }
`
const Spacer = styled.li`
  background: url(${Connector}) no-repeat center center / 110% 100%;
  width: 50%;
  position: relative;
  top: 7px;
  height: 30px;
  margin: 0 -5px;
  transition: all 0.5s;

  @media screen and (min-width: ${minWidth}) {
    display: none;
  }
`
const ActiveSpacer = styled(Spacer)`
  background-image: url(${ActiveConnector});
`

const StepNumber = styled.strong`
  background: #fff;
  color: #757575;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 60px;
  border: 6px solid #dedede;
  font-size: 20px;
  font-weight: bold;
  position: relative;
  z-index: 10;
  transition: all 0.5s;
`
const ActiveStepNumber = styled(StepNumber)`
  color: var(--dark-blue);
  border-color: var(--dark-blue);

  @media screen and (min-width: ${minWidth}) {
    border-color: var(--orange);
  }
`
const CompletedStepNumber = styled(StepNumber)`
  background: var(--light-blue);
  color: var(--dark-blue);
  border-color: var(--dark-blue);
`
const StepName = styled.p`
  position: absolute;
  left: -18px;
  width: 80px;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  line-height: 110%;
  color: #757575;
  transition: all 0.5s;

  @media screen and (min-width: ${minWidth}) {
    position: static;
    width: auto;
    left: 0;
    margin: 0 30px 0 10px;
    text-align: left;
    transition: all 0.5s;
  }

  @media screen and (min-width: 620px) {
    margin: 0 50px 0 10px;
    font-size: 16px;
  }
`
const ActiveStepName = styled(StepName)`
  color: var(--dark-blue);
`

export { ActiveSpacer, ActiveStepName, ActiveStepNumber, CompletedStepNumber, Container, Item, Spacer, StepNumber, StepName }
